import Vue from 'vue'
import Router from 'vue-router'

import Search from '../components/Search.vue'
import Locations from '../components/LocationsSearch.vue'
import Service from '../components/Service.vue'
import Location from '../components/content/Location.vue'
import Organization from '../components/content/Organization.vue'
import FavouriteDisplaySingleList from '@/components/favourite_list/FavouriteDisplaySingleList'
import FavouriteDisplayLists from '@/components/favourite_list/FavouriteDisplayLists'
import SavedSearches from '@/components/save_search/SavedSearches'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Search',
      component: Search,
    },

    {
      path: '/service/:id/:name',
      props: true,
      name: 'Service',
      component: Service,
    },
    {
      path: '/service/:id',
      props: true,
      name: 'Service',
      component: Service,
    },
    {
      path: '/location/:id/:name',
      props: true,
      name: 'Location',
      component: Location,
    },
    {
      path: '/locations',
      props: true,
      name: 'Location',
      component: Locations,
    },
    {
      path: '/organization/:id/:name',
      props: true,
      name: 'Organization',
      component: Organization,
    },
    {
      path: '/favourites/list/:id/:name',
      props: true,
      name: 'Favourite List',
      component: FavouriteDisplaySingleList,
    },
    {
      path: '/favourites/',
      name: 'Favourites',
      component: FavouriteDisplayLists,
    },
    {
      path: '/saved-searches',
      name: 'Saved Searches',
      component: SavedSearches,
    },
  ],
})
// {
//   path: '/favourites',
//   name: 'Favourites',
//   component: displayFavourites
// },
